/* ==========================================================================
   twin.beauty — Verhalten
   Reveal, Header, Drawer, Toast, Warenkorb (AJAX), Katalog (Suche/Sortierung),
   Produktseite (Menge, In den Warenkorb, Galerie). Alle Handler sind an das
   Dokument delegiert, damit per Section-Rendering ersetzte Teile weiter
   funktionieren. Bewegung respektiert prefers-reduced-motion.
   ========================================================================== */
(function () {
  'use strict';
  var d = document, reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var routes = window.routes || {};
  var R = {
    add: routes.cart_add_url || '/cart/add',
    change: routes.cart_change_url || '/cart/change',
    cart: routes.cart_url || '/cart'
  };
  function $(s, r) { return (r || d).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); }

  /* ---------- Reveal beim Scrollen ---------- */
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, { threshold: .1, rootMargin: '0px 0px -8% 0px' }) : null;
  function observe(root) {
    $$('[data-stagger]', root).forEach(function (g) { Array.prototype.forEach.call(g.children, function (c, i) { c.style.setProperty('--i', i); }); });
    $$('.tb-reveal:not(.is-in)', root).forEach(function (el) { io ? io.observe(el) : el.classList.add('is-in'); });
  }

  /* ---------- Header: Glas beim Scrollen, transparent ueber einem Hero am Seitenanfang ---------- */
  var header = $('[data-tb-header]');
  function heroAtTop() { var h = $('[data-tb-hero]'); if (!h) return null; return (h.getBoundingClientRect().top + (window.scrollY || 0)) < 200 ? h : null; }
  function onScroll() {
    if (!header) return;
    var y = window.scrollY || 0, hero = heroAtTop();
    header.classList.toggle('is-scrolled', y > 24);
    header.classList.toggle('is-top', !!hero && y < hero.offsetHeight - 120);
  }
  if (header) { window.addEventListener('scroll', onScroll, { passive: true }); window.addEventListener('resize', onScroll); onScroll(); }
  $$('[data-tb-hero]').forEach(function (h) { requestAnimationFrame(function () { h.classList.add('is-in'); }); });

  /* ---------- Drawer ---------- */
  var burger = $('[data-tb-burger]'), drawer = $('[data-tb-drawer]');
  function setDrawer(open) {
    d.body.classList.toggle('is-drawer-open', open); d.body.style.overflow = open ? 'hidden' : '';
    if (burger) burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (drawer) drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
  }
  d.addEventListener('click', function (e) {
    if (e.target.closest('[data-tb-burger]')) return setDrawer(!d.body.classList.contains('is-drawer-open'));
    if (e.target.closest('[data-tb-drawer-close]') || e.target.closest('[data-tb-drawer] a')) return setDrawer(false);
    var acc = e.target.closest('[data-tb-acc]'); if (acc) acc.classList.toggle('is-open');
  });
  d.addEventListener('keydown', function (e) { if (e.key === 'Escape') setDrawer(false); });

  /* ---------- Toast ---------- */
  var toast = $('[data-tb-toast]'), toastTimer;
  function showToast(msg) {
    if (!toast) return;
    $('[data-tb-toast-text]', toast).textContent = msg;
    toast.classList.add('is-on'); clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.classList.remove('is-on'); }, 2600);
  }

  /* ---------- Warenkorb-Zaehler ---------- */
  function setCount(n, bump) {
    $$('[data-tb-cart-count]').forEach(function (el) {
      el.textContent = n; el.setAttribute('data-count', n);
      if (bump) { el.classList.remove('is-bump'); void el.offsetWidth; el.classList.add('is-bump'); }
    });
  }
  function refreshCount(bump) {
    return fetch(R.cart + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { setCount(c.item_count, bump); return c; }).catch(function () {});
  }

  /* ---------- Mengen-Stepper (Produktseite und Warenkorb) ---------- */
  d.addEventListener('click', function (e) {
    var b = e.target.closest('[data-tb-qty] [data-q]'); if (!b) return;
    var input = $('input', b.closest('[data-tb-qty]')), min = parseInt(input.min, 10) || 0;
    var v = Math.max(min, (parseInt(input.value, 10) || 0) + parseInt(b.dataset.q, 10));
    input.value = v; input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Produktseite: In den Warenkorb (AJAX), Galerie ---------- */
  d.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-tb-add]'); if (!form) return;
    e.preventDefault();
    var btn = $('[type="submit"]', form), note = $('[data-tb-add-error]', form.closest('[data-tb-product]') || form);
    if (btn) btn.classList.add('is-busy'); if (note) note.hidden = true;
    var fd = new FormData(form);
    fetch(R.add + '.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Fehler'); return j; }); })
      .then(function (item) { showToast((item.product_title || 'Artikel') + ' hinzugefügt'); return refreshCount(true); })
      .catch(function (err) { if (note) { note.textContent = err.message; note.hidden = false; } else showToast(err.message); })
      .then(function () { if (btn) btn.classList.remove('is-busy'); });
  });
  d.addEventListener('click', function (e) {
    var t = e.target.closest('[data-tb-thumb]'); if (!t) return;
    var g = t.closest('[data-tb-gallery]');
    $$('[data-tb-thumb]', g).forEach(function (x) { x.classList.toggle('is-active', x === t); });
    $$('.tb-gallery__main img', g).forEach(function (im) { im.classList.toggle('is-current', im.dataset.idx === t.dataset.idx); });
  });
  /* Variantenwahl ueber Pills: setzt die versteckte Varianten-ID und Preis/Verfuegbarkeit */
  d.addEventListener('click', function (e) {
    var p = e.target.closest('[data-tb-variant]'); if (!p) return;
    var root = p.closest('[data-tb-product]'), idInput = $('input[name="id"]', root);
    $$('[data-tb-variant]', root).forEach(function (x) { x.classList.toggle('is-active', x === p); });
    if (idInput) idInput.value = p.dataset.tbVariant;
    var price = $('[data-tb-variant-price]', root); if (price && p.dataset.priceHtml) price.innerHTML = p.dataset.priceHtml;
    var btn = $('form[data-tb-add] [type="submit"]', root), stock = $('[data-tb-stock]', root), avail = p.dataset.available === 'true';
    if (btn) { btn.disabled = !avail; btn.textContent = avail ? btn.dataset.labelAdd : btn.dataset.labelSoldOut; }
    if (stock) stock.textContent = avail ? stock.dataset.labelIn : stock.dataset.labelOut;
  });

  /* ---------- Katalog: Suche und Sortierung ueber die gerenderten Karten ---------- */
  function catalog(root) {
    var grid = $('[data-tb-grid]', root), search = $('[data-tb-search]', root), sort = $('[data-tb-sort]', root), count = $('[data-tb-count]', root), empty = $('[data-tb-empty]', root);
    if (!grid) return;
    var cards = $$('.tb-card', grid), total = cards.length, timer;
    cards.forEach(function (c, i) { c.dataset.index = i; });
    function apply() {
      var q = (search ? search.value : '').trim().toLowerCase(), mode = sort ? sort.value : 'featured', shown = 0;
      var visible = cards.filter(function (c) { var hit = !q || (c.dataset.search || '').toLowerCase().indexOf(q) > -1; c.classList.toggle('is-hidden', !hit); if (hit) shown++; return hit; });
      visible.sort(function (a, b) {
        switch (mode) {
          case 'new': return (+b.dataset.created || 0) - (+a.dataset.created || 0);
          case 'price-asc': return (+a.dataset.price) - (+b.dataset.price);
          case 'price-desc': return (+b.dataset.price) - (+a.dataset.price);
          case 'name': return (a.dataset.title || '').localeCompare(b.dataset.title || '', 'de');
          default: return (+a.dataset.index) - (+b.dataset.index);
        }
      });
      visible.forEach(function (c, i) { c.style.setProperty('--i', Math.min(i, 12)); grid.appendChild(c); });
      if (count) count.textContent = shown === total ? total + ' ' + (count.dataset.labelPlural || 'Produkte') : shown + ' von ' + total;
      if (empty) empty.hidden = shown > 0;
    }
    if (search) search.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(apply, 180); });
    if (sort) sort.addEventListener('change', apply);
    apply();
  }
  $$('[data-tb-catalog]').forEach(catalog);

  /* ---------- Warenkorb: Menge aendern, Entfernen, Section neu rendern ---------- */
  function cartSection(el) {
    var id = el.dataset.sectionId;
    function rerender() {
      return fetch(window.location.pathname + '?section_id=' + id, { headers: { Accept: 'text/html' } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var tmp = d.createElement('div'); tmp.innerHTML = html;
          var fresh = $('[data-tb-cart]', tmp), host = $('[data-tb-cart]');
          if (fresh && host) { host.innerHTML = fresh.innerHTML; $$('.tb-reveal', host).forEach(function (r) { r.classList.add('is-in'); }); }
        });
    }
    function change(key, qty) {
      var host = $('[data-tb-cart]'); if (host) host.classList.add('is-busy');
      return fetch(R.change + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
        .then(function (r) { return r.json(); })
        .then(function (c) { setCount(c.item_count, false); return rerender(); })
        .catch(function () { showToast('Der Warenkorb konnte nicht aktualisiert werden.'); })
        .then(function () { var h = $('[data-tb-cart]'); if (h) h.classList.remove('is-busy'); });
    }
    d.addEventListener('change', function (e) {
      var input = e.target.closest('[data-tb-cart] .tb-cart__row input[type="number"]'); if (!input) return;
      var row = input.closest('.tb-cart__row'), v = Math.max(0, parseInt(input.value, 10) || 0);
      if (v === 0) row.classList.add('is-leaving');
      setTimeout(function () { change(row.dataset.key, v); }, v === 0 && !reduce ? 380 : 0);
    });
    d.addEventListener('click', function (e) {
      var rm = e.target.closest('[data-tb-cart] [data-tb-remove]'); if (!rm) return;
      e.preventDefault(); var row = rm.closest('.tb-cart__row'); row.classList.add('is-leaving');
      setTimeout(function () { change(row.dataset.key, 0); }, reduce ? 0 : 380);
    });
    /* Rabattcode: wird ueber den Discount-Redirect an die Kasse gegeben */
    d.addEventListener('submit', function (e) {
      var f = e.target.closest('[data-tb-coupon]'); if (!f) return;
      e.preventDefault();
      var v = ($('input', f).value || '').trim().toUpperCase(), fb = $('[data-tb-coupon-fb]'), root = $('[data-tb-cart]');
      if (root) root.dataset.discount = v;
      if (fb) fb.textContent = v ? (fb.dataset.labelSet || 'Code wird an der Kasse geprüft') : '';
    });
    d.addEventListener('click', function (e) {
      var c = e.target.closest('[data-tb-checkout]'); if (!c) return;
      var root = $('[data-tb-cart]'), code = root && root.dataset.discount;
      if (code) { e.preventDefault(); window.location.href = (routes.root_url || '/').replace(/\/$/, '') + '/discount/' + encodeURIComponent(code) + '?redirect=%2Fcheckout'; }
    });
  }
  var cartEl = $('[data-tb-cart]'); if (cartEl) cartSection(cartEl);

  /* ---------- Newsletter-Rueckmeldung ---------- */
  if (/customer_posted=true/.test(window.location.search)) { var ok = $('[data-tb-news-ok]'); if (ok) ok.hidden = false; }

  /* ---------- Theme-Editor: neu geladene Sections beobachten ---------- */
  d.addEventListener('shopify:section:load', function (e) { observe(e.target); onScroll(); $$('[data-tb-catalog]', e.target).forEach(catalog); });

  observe();
  window.TB = { toast: showToast, refreshCount: refreshCount, observe: observe };
})();
